/**
 * copy-code.js — nút chép mã giảm giá, dùng chung cho mọi trang (vé mã ở hotdeal.html, popup khuyến mãi
 * ở footer).
 *
 * Markup: một khối chứa <code>MÃ</code> và button[data-copy-code="MÃ"] > i (icon) + span (chữ nút) — hai
 * phần tử đứng cạnh nhau trong cùng cha, vì khi trình duyệt chặn clipboard (http, iframe) thì chọn sẵn
 * chữ trong <code> đó để khách tự Ctrl+C.
 * Chép được: chữ nút đổi "Đã chép" + icon tích 2 giây, gắn .is-copied, báo toast.
 *
 * Vì sao tách khỏi hotdeal.js: popup khuyến mãi nằm trong footer — trang nào cũng có — nên phần chép mã
 * không thể chỉ chạy trong [data-hotdeal]. Bắt sự kiện trên document nên nút chèn sau (popup) vẫn chạy.
 *
 * WP: giữ nguyên file.
 *
 * Viết theo cú pháp ES5 vì pipeline dùng uglify-js sau babel.
 */
(function () {
    'use strict';

    function toast(message) {
        if (window.WBToast) window.WBToast.show(message);
    }

    function selectCode(button) {
        var code = button.parentNode.querySelector('code');
        if (!code || !window.getSelection) return;
        var range = document.createRange();
        range.selectNodeContents(code);
        var selection = window.getSelection();
        selection.removeAllRanges();
        selection.addRange(range);
    }

    function copied(button, code) {
        var label = button.querySelector('span');
        var icon = button.querySelector('i');
        if (label) label.textContent = 'Đã chép';
        if (icon) icon.className = 'ph-bold ph-check';
        button.classList.add('is-copied');
        toast('Đã sao chép mã ' + code + ' — dán ở bước thanh toán');
        window.clearTimeout(button._reset);
        button._reset = window.setTimeout(function () {
            if (label) label.textContent = 'Sao chép';
            if (icon) icon.className = 'ph-bold ph-copy';
            button.classList.remove('is-copied');
        }, 2000);
    }

    function fallback(button, code) {
        selectCode(button);
        toast('Mã ' + code + ' đã được chọn — nhấn Ctrl+C để chép');
    }

    document.addEventListener('click', function (event) {
        var button = event.target.closest ? event.target.closest('[data-copy-code]') : null;
        if (!button) return;
        var code = button.getAttribute('data-copy-code');
        if (navigator.clipboard && window.isSecureContext) {
            navigator.clipboard.writeText(code).then(
                function () {
                    copied(button, code);
                },
                function () {
                    fallback(button, code);
                }
            );
        } else {
            fallback(button, code);
        }
    });
})();
